import React, { useState } from 'react';
import { FAQS } from '../data/coursesData';
import { ChevronDown, HelpCircle } from 'lucide-react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0);
  const [activeCategory, setActiveCategory] = useState('ALL');

  const categories = ['ALL', 'Accreditation & Validity', 'Examinations & Learning', 'Fees & EMI Options', 'Placements & Career'];

  const filteredFaqs = FAQS.filter(faq => {
    return activeCategory === 'ALL' || faq.category === activeCategory;
  });

  return (
    <section id="faqs" style={{ padding: '5rem 0', backgroundColor: '#07131E', color: '#FFFFFF' }}>
      <div className="container" style={{ maxWidth: '900px' }}>

        {/* Section Header */}
        <div style={{ textAlign: 'center', margin: '0 auto 3rem auto' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.4rem',
            backgroundColor: 'rgba(212, 175, 55, 0.15)',
            border: '1px solid rgba(212, 175, 55, 0.3)',
            color: '#FEF08A',
            fontWeight: 700,
            fontSize: '0.82rem',
            padding: '0.35rem 0.9rem',
            borderRadius: '9999px',
            marginBottom: '0.75rem'
          }}>
            <HelpCircle size={14} color="#D4AF37" /> Clear Your Doubts
          </div>
          <h2 style={{ fontSize: '2.3rem', fontWeight: 800, color: '#FFFFFF', letterSpacing: '-0.02em' }}>
            Frequently Asked Questions
          </h2>
          <p style={{ fontSize: '1.05rem', color: '#CBD5E1', marginTop: '0.5rem' }}>
            Got questions about UGC entitlement, proctored exams, or degree validity? We've got answers.
          </p>
        </div>

        {/* Category Pills */}
        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '2rem' }}>
          {categories.map((cat, idx) => (
            <button
              key={idx}
              onClick={() => { setActiveCategory(cat); setOpenIndex(0); }}
              style={{
                padding: '0.55rem 1.1rem',
                borderRadius: '9999px',
                fontSize: '0.85rem',
                fontWeight: activeCategory === cat ? 700 : 500,
                backgroundColor: activeCategory === cat ? '#D4AF37' : '#0F2537',
                color: activeCategory === cat ? '#0F172A' : '#CBD5E1',
                border: activeCategory === cat ? '1.5px solid #D4AF37' : '1px solid rgba(255, 255, 255, 0.15)',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* FAQ Accordion List */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {filteredFaqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className="glass-card"
                style={{
                  padding: '1.25rem 1.5rem',
                  backgroundColor: '#0F2537',
                  borderRadius: '14px',
                  border: isOpen ? '1.5px solid #D4AF37' : '1px solid rgba(255, 255, 255, 0.12)',
                  cursor: 'pointer',
                  transition: 'all 0.25s ease'
                }}
                onClick={() => setOpenIndex(isOpen ? null : index)}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem' }}>
                  <h3 style={{ fontSize: '1.05rem', fontWeight: 700, color: isOpen ? '#FEF08A' : '#FFFFFF', margin: 0, lineHeight: 1.4 }}>
                    {faq.question}
                  </h3>
                  <div style={{
                    transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.25s ease',
                    flexShrink: 0
                  }}>
                    <ChevronDown size={20} color="#D4AF37" />
                  </div>
                </div>

                {isOpen && (
                  <div style={{
                    marginTop: '1rem',
                    paddingTop: '1rem',
                    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                    fontSize: '0.92rem',
                    color: '#CBD5E1',
                    lineHeight: 1.65,
                    animation: 'fadeIn 0.2s ease'
                  }}>
                    {faq.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}
